// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fields {\n  border: 0.5px solid;\n  padding: 5px;\n  margin-bottom: 10px;\n  border-color: #d3d3d3;\n}\n", ""]);
// Exports
module.exports = exports;
